module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/rw-02a8a07e06e4ae9c012213554233b005.svg";